<template>
  <div class="prakerja-card-shimmers pt-8">
    <div class="prakerja-card-shimmers__item w-full" direction="column">
      <BlShimmerAv class="prakerja-card-shimmers__item--big" width="100%" height="98px" />
      <BlFlexContainerMv direction="column" padding="8px">
        <BlShimmerAv class="prakerja-card-shimmers__item--small" width="50%" height="16px" />
        <BlShimmerAv class="prakerja-card-shimmers__item--small" width="80%" height="16px" style="margin-top: 8px" />
        <BlShimmerAv class="prakerja-card-shimmers__item--small" width="50%" height="16px" style="margin-top: 24px" />
      </BlFlexContainerMv>
    </div>
  </div>
</template>

<script>
import {BlFlexContainerMv, BlShimmerAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaCardSmallShimmer',
  components: {
    BlFlexContainerMv,
    BlShimmerAv,
  },
};
</script>

<style lang="scss" scoped>
.prakerja-card-shimmers {
  width: 100%;

  &__item {
    height: 218px;
    background: white;
    filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));
    border-radius: 4px;

    &--big {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    &--small {
      border-radius: 4px;
    }
  }
}
</style>
